import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/sources/fleets/$id/configurations/")({
  staticData: {
    title: "common.configurations",
  },
});
